__turbopack_context__.v({
  "author": "Hero-module-scss-module__L8fAiG__author",
  "black": "Hero-module-scss-module__L8fAiG__black",
  "blink": "Hero-module-scss-module__L8fAiG__blink",
  "h1": "Hero-module-scss-module__L8fAiG__h1",
  "hero": "Hero-module-scss-module__L8fAiG__hero",
  "heroComponent": "Hero-module-scss-module__L8fAiG__heroComponent",
  "heroContent": "Hero-module-scss-module__L8fAiG__heroContent",
  "heroImageContain": "Hero-module-scss-module__L8fAiG__heroImageContain",
  "heroMedia": "Hero-module-scss-module__L8fAiG__heroMedia",
  "heroText": "Hero-module-scss-module__L8fAiG__heroText",
  "stickyTitle": "Hero-module-scss-module__L8fAiG__stickyTitle",
});
